var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenewable1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 485.459,
    height: 413.863,
    viewBox: "0 0 485.459 413.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "renewable",
    transform: "translate(4.977 5.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M224.5-472.93c-45.176,2.975-88.214,22.681-120.842,55.215A192.048,192.048,0,0,0,50.677-317.323c-1.766,9.3-3.532,29.652-3.16,35.695.186,2.6.186,4.74-.093,4.74s-6.507-6.135-13.943-13.571-14.594-14.129-15.988-14.873A11.646,11.646,0,0,0,.853-298.36c-1.952,6.6-.93,7.994,27.329,36.16l26.306,26.213H64.527l26.306-26.307c28.444-28.351,29.467-29.652,27.329-36.252-2.231-6.693-10.132-10.132-16.174-7.064-1.115.558-8.459,7.344-16.174,15.059L71.592-276.423v-8.552c0-41.923,18.126-85.054,48.43-115.451,40.714-40.714,98.532-57.632,154.213-45.176A166.84,166.84,0,0,1,395.447-336.286c1.859,5.3,3.532,9.574,3.811,9.481,5.3-2.231,14.315-4.09,18.126-3.811,2.51.093,4.648,0,4.648-.465,0-.372-1.673-5.764-3.811-12.084A190.53,190.53,0,0,0,284.459-467.632,201.574,201.574,0,0,0,224.5-472.93Z",
    transform: "translate(-0.228 473.325)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M389.2-267.787c-28.444,28.444-29.467,29.746-27.329,36.346,2.231,6.693,10.132,10.132,16.174,7.064,1.115-.558,8.459-7.344,16.267-15.059l14.129-14.129v8.552c0,41.923-18.126,85.054-48.43,115.451C319.3-88.848,261.479-71.93,205.8-84.386,149.468-97.028,102.9-138.858,84.585-193.516,82.912-198.721,81.146-203,80.867-203s-3.532.93-7.065,2.045a32.155,32.155,0,0,1-11.155,1.58c-2.51-.093-4.648,0-4.648.465,0,.372,1.673,5.763,3.811,12.084A190.849,190.849,0,0,0,216.489-58.266c13.85,1.859,39.134,1.859,52.055-.093a190.172,190.172,0,0,0,107.828-53.914,191.517,191.517,0,0,0,52.52-98.161c2.045-10.5,4.09-31.14,3.625-37.926-.186-2.6-.186-4.74.093-4.74s6.507,6.135,13.943,13.571,14.594,14.129,15.988,14.873a11.646,11.646,0,0,0,16.639-6.972c1.952-6.6.93-7.994-27.329-36.16L425.545-294H415.505Z",
    transform: "translate(-4.298 460.692)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 15
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewable1);
export default __webpack_public_path__ + "static/media/renewable1.50b1b3f89fb4015642195f790ad394c3.svg";
export { ForwardRef as ReactComponent };